// extracted by mini-css-extract-plugin
export default {"checklistDescription":"ChecklistDescription__checklistDescription___Xl62i"};